import { lazy, Suspense, useEffect, useState } from "react";
import { hasWebGL, useIsMobile } from "../lib/util";

const CoreCanvas = lazy(() => import("../three/CoreCanvas"));

// Fixed WebGL layer that hosts the NOORIN Core; it pauses when no core section is visible.
export const CoreStage = ({ onReady }) => {
  const mobile = useIsMobile();
  const [active, setActive] = useState(true);
  const gl = hasWebGL();

  useEffect(() => {
    const vis = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => (e.isIntersecting ? vis.add(e.target) : vis.delete(e.target)));
        setActive(vis.size > 0);
      },
      { rootMargin: "5% 0px" },
    );
    document.querySelectorAll("[data-core]").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!gl) onReady?.();
  }, [gl, onReady]);

  if (!gl) return null;
  return (
    <div aria-hidden data-testid="core-stage" className={`pointer-events-none fixed inset-0 z-[1] transition-opacity duration-700 ${active ? "opacity-100" : "opacity-0"}`}>
      <Suspense fallback={null}>
        <CoreCanvas active={active} mobile={mobile} onReady={onReady} />
      </Suspense>
    </div>
  );
};
